<template>
  <div class="sku-info">
    <el-tabs v-model="activeName">
      <el-tab-pane label="SKU信息" name="first">
        <el-table border :data="tableList">
          <el-table-column label="规格名称" prop="productSpec" align="center"></el-table-column>
          <el-table-column label="商品编码" prop="" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productCode" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="成本价" prop="" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.costPrice" placeholder="成本价必须大于零" @input="(value) => watchCostPrice(value, scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="其他价" prop="" align="center" width="1200">
            <template slot-scope="scope">
              <table style="width:100%">
                <thead >
                  <th class="th" style="width:30%">分销商</th>
                  <th class="th" style="width:10%">市场价</th>
                  <th class="th" style="width:10%">商家价</th>
                  <th class="th" style="width:10%">零售价</th>
                  <th class="th" style="width:10%">供货价</th>
                  <th class="th" style="width:10%">上下架</th>
                  <th class="th" style="width:20%;">备注</th>
                </thead>
                <tbody>
                  <tr v-for="(s, i) in scope.row.saleableSkuPriceItems" :key="i">
                    <td style="padding:5px;white-space:nowrap;">
                      <span>{{s.resellerName}}</span>
                    </td>
                    <td style="padding:5px;">
                      <el-input class="cost-price" type="number" placeholder="市场价" v-model="s.marketPrice"
                          style="width:100%;"></el-input>
                    </td>
                    <td style="padding:5px;">
                      <el-input class="cost-price" type="number" placeholder="商家价" v-model="s.merchantsPrice"
                          style="width:100%;"></el-input>
                    </td>
                    <td style="padding:5px;">
                      <el-input class="cost-price" type="number" placeholder="零售价" v-model="s.retailPrice"
                          style="width:100%;"></el-input>
                    </td>
                    <td style="padding:5px;">
                      <el-input class="cost-price" type="number" placeholder="供货价" v-model="s.supplyPrice"
                          style="width:100%;"></el-input>
                    </td>
                    <td class="text-align:center;">
                      <el-switch
                        v-model="s.isShelves"
                        active-color="#13ce66"
                        inactive-color="#ccc">
                      </el-switch>
                    </td>
                    <td style="padding:5px;">
                      {{s.remoteNote}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </el-table-column>
          <el-table-column label="规格图" align="center">
            <template slot-scope="scope">
              <!-- <img
                :src="scope.row.pictureUrl"
                width="120"
                alt="暂无"
                @click="handleLookBigPic(scope.row.pictureUrl)"
              /> -->
              <div class="el_upload_sku">
                <input
                    class="el_upload_input"
                    @change="handleSkuChange($event, scope.row)"
                    id="el_upload_input"
                    type="file"
                />
                <img
                    v-if="scope.row.pictureUrl"
                    :src="scope.row.pictureUrl"
                    class="avatar"
                />
                <i v-else class="el-icon-plus upload-plus"></i>
                <span
                    class="mask"
                    v-if="scope.row.pictureUrl"
                    @click.stop="delSkuPic(scope.row)"
                >
                    <i class="el-icon-delete"></i>
                  </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="deleteSku(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="sbmit_info">
          <el-button type="primary" v-preventClick @click="handleSubmitSku">保存SKU</el-button>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="操作日志" name="second">
        <div>
          <el-form inline>
            <el-form-item label="操作时间："></el-form-item>
            <el-form-item label="操作人："></el-form-item>
            <el-form-item label="创建时间：">
            <el-date-picker
              v-model="valueTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handlePicker"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchFun">筛选</el-button>
              <el-button type="danger" @click="resetFun">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table>
            <el-table-column label="操作时间" align="center"></el-table-column>
            <el-table-column label="操作时间" align="center"></el-table-column>
            <el-table-column label="操作人" align="center"></el-table-column>
            <el-table-column label="操作内容" align="center"></el-table-column>
          </el-table>
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            style="float: right"
          ></el-pagination>
        </div>
      </el-tab-pane> -->
    </el-tabs>
    
  </div>
</template>

<script>
import {
  getQiniuToken,
  ProductSkuGetAllNew,
  BatchCreateAndUpdate,
  ProductSkuDelete
} from '../../../api/api'
export default {
  data() {
    return {
      buttonList_toolBar: [],
      buttonList_table: [],
      activeName: 'first',
      tableList: [],
      qiniuToken: '',
      total: 0,
      valueTime: [],
      productId: this.$route.query.id ? this.$route.query.id : null,
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getTableList()
    }
    this.getQiniuToken()
  },
  methods: {
    watchCostPrice(val, data) {
      if (val <= 0) {
        data.costPrice = null
      }
    },
    searchFun() {

    },
    resetFun() {

    },
    handlePicker() {

    },
    handleCurrentChange(val) {
      // this.PageIndex = val;
      // this.getSkuList();
    },
    handleSizeChange(e) {
      // this.PageSize = e;
      // this.getSkuList();
    },
    getTableList() {
      ProductSkuGetAllNew({ProductId: this.productId}).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result.items || []
        }
      })
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
    },
    handleSkuChange(e, row) {
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file, qiniuData).then((res) => {
        window.document.getElementById("el_upload_input").value = null;
        row.pictureUrl = res
      })
      .catch((err) => {
        that.$message.error(err);
      });
    },
    delSkuPic(item) {
      item.pictureUrl = ''
      // this.tableList[i].pictureUrl = "";
    },
    handleSubmitSku() {
      let items = JSON.parse(JSON.stringify(this.tableList))
      items.forEach(i => {
        i.saleableSkuItems = []
        i.saleableSkuPriceItems.forEach(s => {
          i.saleableSkuItems.push({
            "saleableSkuId": s.saleableSkuId,
            "supplyPrice": s.supplyPrice,
            "retailPrice": s.retailPrice,
            "merchantsPrice": s.merchantsPrice,
            "marketPrice": s.marketPrice,
            "isShelves": s.isShelves
          })
        })
      })
      let data = {
        productId: this.productId,
        items
      }
      BatchCreateAndUpdate(data).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
          this.getTableList()
          setTimeout(() => {
            this.$router.push('/Product/SkuList/Index')
          }, 1000);
        }
      })
    },
    deleteSku(data) {
      ProductSkuDelete({ids: [data.id]}).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getTableList()
        }
      })
    },
  }
}
</script>

<style scoped>
.sku-info{
  padding: 0 20px;
}
.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.el_upload_sku {
  margin: 0 auto;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-plus{
  /* width: 100px;
  height: 100px; */
  font-size: 24px;
}
.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}
.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.th{
  padding:5px 0;
  text-align:center;
  white-space:nowrap;
}
</style>